$(document).ready(function(){

  
    //if the variant selector is available on  PRODUCT PAGES
	if($("select").length)
	{
      //set a var to hold the search value
      var search = '';
      
      //loop through each option
      $("select > option").each(function(){
        
        //find if disabled
        if(this.hasAttribute('disabled'))
        {
          
          //get the text in the option so we can find the associated option in the user visible selector and assign to variable
          search = $(this).text();

          //find the option in user visible selector with matching text and set to grey and add out of stock text
          
          $(this).attr("style", "color:grey");
          $(this).text(search+" (out of stock)");

          $(".single-option-selector option:contains("+search+")").text(search+" (out of stock)");
          $(".single-option-selector option:contains("+search+")").attr("style", "color:grey");

      
        }
      });
	}


    //add auction badge
    if($("#codeBlock-auction-widget-wrapper").length)
    {

      $(".product__images").addClass("auction-item");
      $(".product-block--price, .iwish-app-block-wrapper, .items_left, .product-quantity-box").css("display","none");
    }

    //remove the buy with shoppay button from bundles
    if($('#rbr-container-element-true').length)
    {
      $('.shopify-payment-button').css('display','none');
    }
    if($('#rbr-container-element-false').length)
    {
      $('.shopify-payment-button').css('display','none');
    }

  
  
   
});